"use client";

import { Theme } from "@radix-ui/themes";
export const Providers = ({ children, rest }) => (
  <Theme
    appearance="dark"
    // accentColor="indigo"
    accentColor="jade"
    grayColor="mauve"
    panelBackground="solid"
    radius="small"
    hasBackground
  >
    {children}
  </Theme>
);
